<template>
    <b-button href="https://courses.plschool.ru/" variant="custom-green" class="font-weight-bold" target="_blank">ОБУЧАЮЩИЙ КУРС</b-button>
</template>

<script>
export default {
    name: "online-course-regular-button"
}
</script>
